import qs from './qs';

function changeColor() {
  const testType = qs('test');

  const primary = qs('primary');
  const secondary = qs('secondary');

  const latencyColor = qs('latency');
  const jitterColor = qs('jitter');
  const downloadColor = qs('download');
  const uploadColor = qs('upload');

  if (testType === 'animated') {
    let jitterCss = '';

    if (jitterColor === 'hidden') {
      jitterCss = '.box--jitter { display: none; }';
    } else if (jitterColor) {
      // Done differently because it was added later: might not be specified
      jitterCss = `
        .test-animated-el .box--jitter {
          color: ${jitterColor};
          background: ${jitterColor};
        }
      `;
    }

    if (!latencyColor || !downloadColor || !uploadColor || !primary) {
      return jitterCss;
    }

    return `
    .test-animated-el .box--upload {
      color: ${uploadColor};
      background: ${uploadColor};
    }
    .test-animated-el .box--download {
      color: ${downloadColor};
      background: ${downloadColor};
    }
    .test-animated-el .box--latency {
      color: ${latencyColor};
      background: ${latencyColor};
    }
    ${jitterCss}
    .test-animated-el .test-info {
      color: ${primary};
    }`;
  }

  if (!primary || !secondary) {
    return '';
  }

  return `
  .test-default-el .gauge__face .gauge__arc--active {
    stroke: ${secondary};
  }

  .test-default-el .gauge__needle .gauge__needle--part1 {
    fill: ${primary};
    stroke: ${primary};
  }

  .test-default-el .gauge__needle .gauge__needle--part2 {
    fill: ${primary};
  }

  .test-default-el .gauge__needle circle {
    fill: ${primary};
  }

  .test-default-el .start-button {
    background-color: ${secondary};
  }

  .test-default-el .status-bar {
    color: ${secondary};
  }`;
}

function changeResultsVisibility() {
  if (qs('show-results') === 'false') {
    return '.results { display: none !important }';
  }

  return '';
}

function changeBrandingVisibility() {
  if (qs('show-branding') === 'false') {
    return '.byline { display: none }';
  }

  return '';
}

function changeStatusSize() {
  if (qs('status') === 'result') {
    return '.status-bar { font-size: 1.5em; padding-top: 0; }';
  }

  return '';
}

export default function changeStyles() {
  const colorCss = changeColor();
  const resultsCss = changeResultsVisibility();
  const brandingCss = changeBrandingVisibility();
  const statusCss = changeStatusSize();

  if (colorCss || resultsCss || brandingCss || statusCss) {
    const styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    styleEl.innerHTML = colorCss + resultsCss + brandingCss + statusCss;

    document.head.appendChild(styleEl);
  }

  const className = qs('test') || 'default';

  document.body.classList.add(`test-${className}`);
}



// WEBPACK FOOTER //
// ./src/js/lib/change-styles.js